import { Component, Inject, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'vex-full-view-diet',
  templateUrl: './full-view-diet.component.html',
  styleUrls: ['./full-view-diet.component.scss']
})
export class FullViewDietComponent implements OnInit {
  dieta: any;
  environmentNode = environment.baseURL.node;
  giorniSettimana: string[] = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'];

  constructor(public translate: TranslateService) {

  }

  ngOnInit(): void {
    const data = localStorage.getItem('dietRecipe');
    if (data) {
      this.dieta = JSON.parse(data);
      window.addEventListener('storage', (event) => {
        if (event.key === 'dietRecipe') {
          this.dieta = JSON.parse(event.newValue);
        }
      });
    }
  }

  getRicettaNome(categoria: string, index: number): string {
    const ricetta = this.dieta?.[categoria]?.[index];
    return ricetta?.i18nTitle[this.translate.currentLang.toUpperCase()];
  }

  getImage(ricetta: any): string {
    return ricetta?.imagePath ? this.environmentNode + '/get-recipe-image/' + ricetta._id : '';
  }
}
